export default __webpack_public_path__ + "static/media/like.ffb26543.png";